module.exports = __webpack_public_path__ + "img/slothtech.82545b0d.jpg";